import script from "./UiPill.vue.ts?vue&type=script&lang=ts&setup=true!=!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0]!./UiPill.vue?vue&type=script&lang=ts&setup=true"
export * from "./UiPill.vue.ts?vue&type=script&lang=ts&setup=true!=!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0]!./UiPill.vue?vue&type=script&lang=ts&setup=true"

const cssModules = {}
import style0 from "./UiPill.vue.scss?vue&type=style&index=0&id=bb84f00b&lang=scss&module=true!=!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0]!./UiPill.vue?vue&type=style&index=0&id=bb84f00b&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules]])

export default __exports__